import { render } from "./BillingDiscountView.vue?vue&type=template&id=654d5716&scoped=true&lang=pug"
import script from "./BillingDiscountView.vue?vue&type=script&lang=js"
export * from "./BillingDiscountView.vue?vue&type=script&lang=js"

import "./BillingDiscountView.vue?vue&type=style&index=0&id=654d5716&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654d5716"]])

export default __exports__